/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import MeshSpiralMaterial from './materials/MeshSpiralMaterial'
import { useFrame } from '@react-three/fiber'
import { useControls } from 'leva'

export default function FlashSpiral(props) 
{
    const self = useRef()

    const colorFront = '#022028'
    const colorBack = '#3DF5FF'
       

    const { nodes } = useGLTF('./models/orb.glb')

    useFrame( ( state, delta ) =>
    {

    })


    return (
        <group {...props} dispose={null}>
            <mesh name="Sphere" geometry={nodes.Sphere.geometry} ref={ self }>
                <MeshSpiralMaterial
                    frontColor={ colorFront }
                    backColor={ colorBack }
                    colorBoth={ true }
                    intensity={ 1.5 }
                />
            </mesh>
        </group>
    )
}

useGLTF.preload('./models/orb.glb')